import { render, staticRenderFns } from "./seatView.vue?vue&type=template&id=138ae49e&scoped=true&"
import script from "./seatView.vue?vue&type=script&lang=js&"
export * from "./seatView.vue?vue&type=script&lang=js&"
import style0 from "./seatView.vue?vue&type=style&index=0&id=138ae49e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138ae49e",
  null
  
)

export default component.exports